import { sectionRenderer } from '@theme/section-renderer';

class BulkBuyer extends HTMLElement {

  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this._category_buttons = this.querySelectorAll('.bulk-order__category-list button');
    this._all_collections = this.querySelectorAll('.bulk-order__collection');
    this.tabs = document.querySelectorAll('.bulk-order__tabs button');

    this._category_buttons.forEach((button) => { 

        button.addEventListener('click', (e) => { this.toggleCategory(button); });

     });

     this.tabs.forEach((tab) => {

        tab.addEventListener('click', (e) => {
            e.preventDefault();

            let _reference = tab.dataset.tab;

            this.tabs?.forEach((tb) => {
                tb.classList.remove('active');
            });

            document.querySelectorAll('.bulk-order__tab-content').forEach((tcontent) => {
                tcontent.classList.add('hidden');
            });

            document.querySelector(`[data-type="${_reference}"]`)?.classList.remove('hidden');
            document.querySelector(`[data-type="${_reference}"]`)?.classList.add('active');
            tab.classList.add('active');

        });

     });
    
  }

  toggleCategory(button) {

    let _id = button.dataset.category;
    let _type = button.dataset.type;

    if (_id) {
        const url = new URL(`/collections/${_id}`, window.location.origin);
        url.searchParams.set('sections', `bulk-order-${_type}`);
        url.searchParams.set('page', 1);

        let _loadingHTML = `<div class="bulk-loading">
                        <svg
                            aria-hidden="true"
                            focusable="false"
                            class="spinner"
                            viewBox="0 0 66 66"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                        </div>`;

        document.querySelectorAll(`.bulk-order__tab-content[data-type="${_type}"] .bulk-order__collection`).forEach((bcol) => bcol.remove());               
        document.querySelector('.bulk-order__inner')?.insertAdjacentHTML('beforeend', _loadingHTML);


        fetch(url.toString())
            .then((res) => res.json())
            .then((data) => {
                const html = data[`bulk-order-${_type}`];
                if (!html) return;

                setTimeout(() => {
                    document.querySelector('.bulk-loading')?.remove();
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(html, "text/html");

                    let _section = doc.querySelector('.bulk-order__collection');

                    document
                        .querySelector(`.bulk-order__tab-content[data-type="${_type}"`)
                        .append(_section);
                }, 250);

            });
    }


    let _filtered_collections = Array.from(this._all_collections ?? []).filter((col) => col.dataset.category === button.dataset.category);

    this._all_collections?.forEach((collection) => { collection.setAttribute('hidden', 'true') });
    this._category_buttons?.forEach((btn) => { btn.classList.remove('active') });

    button.classList.add('active');

    _filtered_collections.forEach((collection) => {
        collection.removeAttribute('hidden');
    });

  }

}

if (!customElements.get('bulk-buyer')) {
  customElements.define('bulk-buyer', BulkBuyer);
}



class BulkItem extends HTMLElement {

    #controller = new AbortController();

    connectedCallback() {
        const { signal } = this.#controller;

        this._all_quantities = this.querySelectorAll('select');
        this.total_quantity = this.querySelector('.total-items');
        this.total_price = this.querySelector('.total-price');
        this.atc = this.querySelector('.add-to-cart');

        /** @type {any[]} */
        this.currentCart = [];

        this._all_quantities.forEach((select) => {
            select.addEventListener('change', (e) => {
                this.calculateTotal();
            });
        });

        this.atc?.addEventListener('click', (e) => {
            e.preventDefault();
            this.addTocart();
        });

    }

    calculateTotal() {

        let _total_quantity = 0;
        let _total_price = 0;
        

        this._all_quantities?.forEach((select) => {

            let _priceRow = select.closest('.bulk-order__product-quantity')?.querySelector('.bulk-order__row-cost span');

            if (select.value > 0) {

                let _selectedVariant = select.closest('.bulk-order__product-quantity')?.querySelector('.bulk-options');
                
                if (_selectedVariant) {

    
                    if (select.value > 0 && select.id.includes('quantity')) {

                        _total_quantity = _total_quantity + parseInt(select.value);
                        
                        
                        let _selectedVariantPrice = _selectedVariant.options[_selectedVariant.selectedIndex].dataset.price;
                        let _price = Number(select.dataset.price);
    
                        if (_selectedVariant && _selectedVariant != 0) {

                            _price = _selectedVariantPrice;
                        }
    
                        let _tempPrice = _price * select.value;

                        if (_priceRow && !isNaN(_tempPrice)) {
                            _priceRow.textContent = Theme.customer.currency + _tempPrice.toFixed(2);
                        }
                        
                        if (!isNaN(_tempPrice)) {
                            
                            _total_price = _total_price + _tempPrice;

                        }

    
                    }
    
                } else {
    
                    if (select.value > 0 && select.id.includes('quantity')) {
                        _total_quantity = _total_quantity + parseInt(select.value);
    
                        let _price = Number(select.dataset.price);
    
                        let _tempPrice = _price * select.value;

                        if (_priceRow) {
                            _priceRow.textContent = Theme.customer.currency + _tempPrice.toFixed(2);
                        }
    
                        _total_price = _total_price + _tempPrice;
    
                    }
    
                }

            } else {
                _priceRow.textContent = Theme.customer.currency + 0;
            }


        });

        if (this.total_quantity) {
            this.total_quantity.textContent = String(_total_quantity);
            this.total_price.textContent = Theme.customer.currency + _total_price.toFixed(2);
        }

    }

    async addTocart() {

        let formData = {
            'items': []
        };

        this._all_quantities?.forEach((select) => {

            if (select.value > 0 && select.id.includes('quantity')) {

                let _defaultSelected = Number(select.id.replace('quantity-', ''));

                let _selectedVariant = select.closest('.bulk-order__product-quantity')?.querySelector('.bulk-options')?.value;

                if (_selectedVariant && _selectedVariant != 0) {
                    _defaultSelected = Number(_selectedVariant);
                }

                formData.items.push({
                    'id': _defaultSelected,
                    'quantity': Number(select.value)
                });

            }

        });

        if (formData.items.length > 0) {

            // disable button

            this.atc?.setAttribute('disabled', 'true');

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                return response.json();
            })
            .then(response => {
    
                //set quantities to zero
                this._all_quantities?.forEach((select) => {
    
                    select.value = 0;
    
                });
    
                //enable button
                this.atc?.removeAttribute('disabled');
                this.atc?.querySelector('.default')?.classList.add('hidden');
                this.atc?.querySelector('.bulk-order__atc')?.classList.remove('hidden');

                setTimeout(async () => {
                    this.atc?.querySelector('.default')?.classList.remove('hidden');
                    this.atc?.querySelector('.bulk-order__atc')?.classList.add('hidden');

                    const response = await fetch('/cart.js');
                    const cart = await response.json();

                    const cartIcon = document.querySelector('.header-actions__cart-icon');
                    const drawers = document.querySelector('cart-drawer-component');
                    const cartItems = document.querySelector('cart-items-component');

                    if (cartItems) {
                        sectionRenderer.renderSection(cartItems.dataset.sectionId, { cache: false });
                        console.log(cartItems);
                        console.log(cart);
                    }
                    cartIcon.renderCartBubble(cart.item_count, false);
                    drawers?.open();


                    if (this.total_quantity) {
                        this.total_quantity.textContent = 0;
                        this.total_price.textContent = Theme.customer.currency + 0;
                    }

                }, 250);
    
            })
            .catch((error) => {
                console.error('Error:', error);
            });

        }

    }

}

if (!customElements.get('bulk-item')) {
    customElements.define('bulk-item', BulkItem);
}
